import { render } from "./CommercialPageMiddleSectionCms.vue?vue&type=template&id=c7b5d3e4"
import script from "../js/commercial-page-middle-section-cms.js?vue&type=script&lang=js"
export * from "../js/commercial-page-middle-section-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__